import { type BitkitIconComponent } from '@bitrise/bitkit-v2';

import { BuildCacheToolIds, buildCacheTools } from '@/models/BuildCacheTool';

type TabToolId =
  BuildCacheToolIds.gradle | BuildCacheToolIds.bazel | BuildCacheToolIds.xcode | BuildCacheToolIds.reactNative;

const TAB_ORDER: TabToolId[] = [
  BuildCacheToolIds.gradle,
  BuildCacheToolIds.bazel,
  BuildCacheToolIds.xcode,
  BuildCacheToolIds.reactNative,
];

type Tab = { iconComponent: BitkitIconComponent; id: BuildCacheToolIds; title: string };

export const getTabList = (): Tab[] =>
  TAB_ORDER.map((id) => ({
    iconComponent: buildCacheTools[id].iconComponent,
    id,
    title: buildCacheTools[id].name,
  }));
